<template lang="pug">
v-menu(absolute, offset-y, close-on-content-click)
  template(v-slot:activator="{ on, attrs }")
    v-btn(v-on="on", color="primary") Pilihan
  v-list.menu-btn-sm.my-1(dense)
    v-list-item(v-if="view")
      v-btn(color="primary", @click="onView") View Data
        v-spacer
        v-icon mdi-file-find
    v-list-item(v-if="viewPhri")
      v-btn(color="primary", @click="onViewPhri") View Data
        v-spacer
        v-icon mdi-file-find
    v-list-item(v-if="process")
      v-btn(color="primary", @click="onProcess") Proses Data
        v-spacer
        v-icon mdi-autorenew
    v-list-item(v-if="check")
      v-btn(color="success", @click="onCheck") Pilih Data
        v-spacer
        v-icon mdi-check-circle-outline
    v-list-item(v-if="update") 
      v-btn(color="success", @click="onUpdate") Ubah Data
        v-spacer
        v-icon mdi-pencil
    v-list-item(v-if="reset")
      v-btn(color="warning", @click="onReset") Reset Password
        v-spacer
        v-icon mdi-reload
    v-list-item(v-if="resetPin")
      v-btn(color="warning", @click="onResetPin") Reset PIN
        v-spacer
        v-icon mdi-reload
    v-list-item(v-if="blocked") 
      v-btn(color="warning", @click="onBlocked") Blokir
        v-spacer
        v-icon mdi-lock-outline
    v-list-item(v-if="unblocked") 
      v-btn(color="warning", @click="onUnblocked") Buka Blokir
        v-spacer
        v-icon mdi-lock-open-outline
    v-list-item(v-if="del")
      v-btn(color="error", @click="onDelete") Hapus Data
        v-spacer
        v-icon mdi-close
    v-list-item(v-if="download")
      v-btn(color="success", @click="onDownload") Download
        v-spacer
        v-icon mdi-download
    v-list-item(v-if="send")
      v-btn(color="warning", @click="onSend") Kirim
        v-spacer
        v-icon mdi-send
    v-list-item(v-if="approve")
      v-btn(color="success", @click="onApprove") Setuju
        v-spacer
        v-icon mdi-check-all
    v-list-item(v-if="reject")
      v-btn(color="error", @click="onReject") Tolak
        v-spacer
        v-icon mdi-close-circle-outline
    v-list-item(v-if="reinquiry")
      v-btn(color="warning", @click="onReinquiry") Cek Status
        v-spacer
        v-icon mdi-file-sync
    v-list-item(v-if="reverse")
      v-btn(color="error", @click="onReverse") Reversal
        v-spacer
        v-icon mdi-file-cancel
    v-list-item(v-if="createBill")
      v-btn(color="success", @click="onCreateBill") Create Billing
        v-spacer
        v-icon mdi-file-edit
    
</template>
<script>
export default {
  name: "FButtonOption",
  props: ["view", "update", "del", "process", "reset", "check", "download", "send", 
    "blocked", "unblocked", "approve", "reject", "resetPin", "reinquiry", "reverse", "createBill", "viewPhri"],
  methods: {
    onView() {
      this.$emit("view");
    },
    onViewPhri() {
      this.$emit("viewPhri");
    },
    onUpdate() {
      this.$emit("update");
    },
    onDelete() {
      this.$emit("delete");
    },
    onProcess() {
      this.$emit("process");
    },
    onReset() {
      this.$emit("reset");
    },
    onCheck() {
      this.$emit("check");
    },
    onDownload() {
      this.$emit("download");
    },
    onSend() {
      this.$emit("send");
    },
    onBlocked() {
      this.$emit("blocked");
    },
    onUnblocked() {
      this.$emit("unblocked");
    },
    onApprove() {
      this.$emit("approve");
    },
    onReject() {
      this.$emit("reject");
    },
    onResetPin() {
      this.$emit("resetPin");
    },
    onReinquiry() {
      this.$emit("reinquiry");
    },
    onReverse() {
      this.$emit("reverse");
    },
    onCreateBill() {
      this.$emit("createBill");
    },
  },
};
</script>